export class Entidade<T> {
  public id: T
}
